import {config} from "../config";

export class Utils {

    public static redirectToCasinoPage(): void {
        if (top && top.window) {
            top.window.location.replace(config.pageAddress);
        } else {
            window.location.replace(config.pageAddress);
        }
    }

    public static getUrlVars(): any {
        const params: any = {};

        if (location.search) {
            const parts: string[] = location.search.substring(1).split("&");

            for (let i: number = 0; i < parts.length; i++) {
                const nv: string[] = parts[i].split("=");
                if (!nv[0]) {
                    continue;
                }
                params[nv[0]] = nv[1] || true;
            }
        }
        return params;
    }

    public static async requestTimeout(delay: number): Promise<any> {
        return new Promise((resolve) => {
            if (!(window as any).requestAnimationFrame &&
                !(window as any).webkitRequestAnimationFrame &&
                !((window as any).mozRequestAnimationFrame && (window as any).mozCancelRequestAnimationFrame) &&
                !(window as any).oRequestAnimationFrame &&
                !(window as any).msRequestAnimationFrame) {
                return window.setTimeout(resolve, delay);
            }

            const start = new Date().getTime(),
                handle: any = {};

            function loop(): void {
                const current = new Date().getTime(),
                    delta = current - start;

                delta >= delay ? resolve() : handle.value = requestAnimationFrame(loop);
            }

            handle.value = requestAnimationFrame(loop);
        });
    }

    public static getRandomInt(min: number, max: number): number {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    public static areArraysOfNumbersSame(arr1: Array<number>, arr2: Array<number>): boolean {
        if (arr1 && arr2) {
            return (JSON.stringify(arr1.sort()) === JSON.stringify(arr2.sort()));
        }
        return false;
    }

    public static roundWithPrecision(num: number, precision: number): number {
        const multiplier = Math.pow(10, precision);
        return Math.round(num * multiplier) / multiplier;
    }

    // Amounts shown to the player; extremely small bets go down to 0.001 so they need a third decimal.
    public static formatAmount(amount: number): string {
        return amount.toFixed(config.extremelySmallBets ? 3 : 2);
    }
}



// WEBPACK FOOTER //
// ./src/app/Utils.ts